import {
    FILTERS_MAX_AREA,
    FILTERS_MAX_PRICE,
    FILTERS_MAX_ROOMS,
    FILTERS_MIN_AREA,
    FILTERS_MIN_PRICE,
    FILTERS_MIN_ROOMS,
    ShowingFilter
} from 'features/search/filters/constants';

import {SearchFilters as SearchFiltersType, SearchResult} from "features/search/types";

export const getFilterCount = (filters: SearchFiltersType, isMobile: boolean) => {

    let count = 0;

    count = (filters.inhabitDate.length > 0) ? count + 1 : count;
    count = (filters.residenceType.length > 0) ? count + 1 : count;
    count = (filters.concepts.length > 0) ? count + 1 : count;
    count = (filters.minArea !== FILTERS_MIN_AREA || filters.maxArea !== FILTERS_MAX_AREA ) ? count + 1 : count;
    count = (filters.rooms.length > 0 && isMobile) ? count + 1 : count;
    count = ((filters.minPrice !== FILTERS_MIN_PRICE || filters.maxPrice !== FILTERS_MAX_PRICE) && isMobile  ) ? count + 1 : count;
    count = (filters.attributes.length > 0) ? count + 1 : count;
    count = (filters.projectStatus.length > 0) ? count + 1 : count;
    count = (filters.viewing != ShowingFilter.IncludeAll) ? count + 1 : count;
    count = (filters.disposalForm.length > 0) ? count + 1 : count;

    return count;
};

export const getFilterCountResidenceExplorer = (filters: { minArea: number; maxArea: number; minRooms: number; maxRooms: number; minPrice: number; maxPrice: number }, isMobile: boolean) => {
    let count = 0;

    count = (filters.minArea !== FILTERS_MIN_AREA || filters.maxArea !== FILTERS_MAX_AREA ) ? count + 1 : count;
    count = ((filters.minRooms !== FILTERS_MIN_ROOMS || filters.maxRooms !== FILTERS_MAX_ROOMS) && isMobile) ? count + 1 : count;
    count = ((filters.minPrice !== FILTERS_MIN_PRICE || filters.maxPrice !== FILTERS_MAX_PRICE) && isMobile  ) ? count + 1 : count;

    return count;
};

export const isRoomFilterActive = (rooms: string[]) => {
    return rooms.length > 0;
};

export const isPriceFilterActive = (minPrice: number, maxPrice: number) => {
    return ((minPrice !== FILTERS_MIN_PRICE || maxPrice !== FILTERS_MAX_PRICE))
};

export const isAreaFilterActive = (minArea: number, maxArea: number) => {
    return ((minArea !== FILTERS_MIN_AREA || maxArea !== FILTERS_MAX_AREA))
};
export const priceFilter = (minPrice: number, maxPrice: number) => (searchObject: SearchResult) => {
    if (searchObject.price) {
        return searchObject.price <= maxPrice
            && searchObject.price >= minPrice
            || (maxPrice === FILTERS_MAX_PRICE && searchObject.price > FILTERS_MAX_PRICE);
    } else {
        return minPrice === FILTERS_MIN_PRICE && maxPrice === FILTERS_MAX_PRICE;
    }

};
export const roomFilter = (minRooms: number, maxRooms: number) => (searchObject: SearchResult) => {
    if (searchObject.rooms) {
        return (searchObject.rooms <= maxRooms
                && searchObject.rooms >= minRooms)
            || (searchObject.possibleRooms <= maxRooms
                && searchObject.possibleRooms >= minRooms)
            || (maxRooms === FILTERS_MAX_ROOMS && searchObject.rooms > FILTERS_MAX_ROOMS);
    } else {
        return minRooms === FILTERS_MIN_ROOMS && maxRooms === FILTERS_MAX_ROOMS;
    }

};

export const areaFilterNoBra = (minArea: number, maxArea: number) => (searchObject: SearchResult) => {
    if (searchObject.jmnoBraInternal) {
        return searchObject.jmnoBraInternal <= maxArea
            && searchObject.jmnoBraInternal >= minArea
            || maxArea === FILTERS_MAX_AREA && searchObject.jmnoBraInternal > FILTERS_MAX_AREA;
    } else if (searchObject.primaryArea) {
        return searchObject.primaryArea <= maxArea
            && searchObject.primaryArea >= minArea
            || maxArea === FILTERS_MAX_AREA && searchObject.primaryArea > FILTERS_MAX_AREA;
    } else {
        return minArea === FILTERS_MIN_AREA && maxArea === FILTERS_MAX_AREA;
    }
};
export const areaFilter = (minArea: number, maxArea: number) => (searchObject: SearchResult) => {
    if (searchObject.primaryArea) {
        return searchObject.primaryArea <= maxArea
            && searchObject.primaryArea >= minArea
            || maxArea === FILTERS_MAX_AREA && searchObject.primaryArea > FILTERS_MAX_AREA;
    } else {
        return minArea === FILTERS_MIN_AREA && maxArea === FILTERS_MAX_AREA;
    }
};
